import { render, staticRenderFns } from "./ViewFormUser.vue?vue&type=template&id=b852f15c&scoped=true"
import script from "./ViewFormUser.vue?vue&type=script&lang=js"
export * from "./ViewFormUser.vue?vue&type=script&lang=js"
import style0 from "./ViewFormUser.vue?vue&type=style&index=0&id=b852f15c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b852f15c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b852f15c')) {
      api.createRecord('b852f15c', component.options)
    } else {
      api.reload('b852f15c', component.options)
    }
    module.hot.accept("./ViewFormUser.vue?vue&type=template&id=b852f15c&scoped=true", function () {
      api.rerender('b852f15c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/csgOrder/internal/components/ViewFormUser.vue"
export default component.exports